import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import mobileAppPreview from "../../assets/images/mobile-app-promo/Frame28444.png";
import appStoreIcon from "../../assets/images/mobile-app-promo/app-store.svg";
import googlePlayIcon from "../../assets/images/mobile-app-promo/google-play.svg";
import Loading from "../shared/Loading/Loading";
import { User } from "../../services";
import styles from "./MobileAppPromo.module.scss";

const CLIENT_APP_MAGIC_LINK = "https://biny.co/client-app";
const APP_STORE_URL = `${CLIENT_APP_MAGIC_LINK}?source=app_store`;
const GOOGLE_PLAY_URL = `${CLIENT_APP_MAGIC_LINK}?source=google_play`;

const MobileAppPromo = () => {
  const { t } = useTranslation();
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    let isMounted = true;

    User.get()
      .then(() => {
        if (isMounted) {
          setIsAuthorized(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!isAuthorized) {
    return <Loading height="100vh" />;
  }

  return (
    <section className={styles.screen} aria-labelledby="mobile-app-promo-title">
      <div className={styles.hero} aria-hidden="true">
        <img className={styles.heroImage} src={mobileAppPreview} alt="" />
      </div>

      <div className={styles.content}>
        <div className={styles.copy}>
          <h1 id="mobile-app-promo-title" className={styles.title}>
            {t("mobileAppPromo.title")}
          </h1>
          <p className={styles.description}>{t("mobileAppPromo.description")}</p>
        </div>

        <div className={styles.actions}>
          <a
            className={styles.storeLink}
            href={APP_STORE_URL}
            target="_blank"
            rel="noreferrer"
          >
            <span>{t("mobileAppPromo.appStoreLink")}</span>
            <img src={appStoreIcon} alt="" />
          </a>
          <a
            className={styles.storeLink}
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noreferrer"
          >
            <span>{t("mobileAppPromo.googlePlayLink")}</span>
            <img src={googlePlayIcon} alt="" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default MobileAppPromo;
